module.exports = __webpack_public_path__ + "static/img/组 2896.89a3140.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/advisory/images/组 2896.png
// module id = vo+G
// module chunks = 0